import { TeamHeading, PageHeading } from "@/components/Layout/Parts";
import TopVideosTable from "./components/TopVideosTable";
const TopVideos = () => {
  return (
    <>
      <TeamHeading />
      <PageHeading>Top Videos</PageHeading>
      <TopVideosTable />
    </>
  );
};

export default TopVideos;
